import { useCallback, useState, useMemo } from "react";
import { withdraw } from "../../../services/commercialService";

export const useSubmissionActions = ({ quote, afterWithdraw }) => {
  const [withdrawing, setWithdrawing] = useState(false);

  const handleWithdraw = useCallback(async () => {
    setWithdrawing(true);

    /**
     * NOTE: withrawing submissions on an account must occur one-at-a-time
     * Trying to withdraw in parallel results in a Database bean conflict error
     * example funciton at /features/support/hooks.js
     */
    const { linesOfBusiness } = quote;
    for (const submission of linesOfBusiness) {
      const { quoteNumber, lineOfBusiness } = submission;
      if (quote?.status === "Withdrawn") {
        console.log(
          `quote already withdrawn: ${lineOfBusiness} ${quoteNumber}`
        );
        break;
      }
      if (submission?.status === "Withdrawn") {
        console.log(
          `submission already withdrawn: ${lineOfBusiness} ${quoteNumber}`
        );
        continue;
      } else {
        await withdraw({ quoteId: quoteNumber }).catch(async e =>
          console.error(
            `withdraw unsuccessful for ${lineOfBusiness} ${quoteNumber}`,
            e
          )
        );
      }
      if (afterWithdraw)
        await afterWithdraw({
          changedQuote: { ...quote, status: "Not Taken" }
        });
    }

    setWithdrawing(false);
    return true;
  }, [afterWithdraw, quote]);

  return useMemo(
    () => ({ handleWithdraw, withdrawing }),
    [handleWithdraw, withdrawing]
  );
};
